import {SummaryModel} from "../../../entity/summary.model";
import {PermissionsModel} from "../../../entity/permissions.model";

export class BusinessContextSummaryModel implements SummaryModel {
    id: number;
    entityId: number;
    name: string;
    permissions: PermissionsModel;

    constructor(entityId?: number, name?: string) {
        this.entityId = entityId;
        this.name = name;
    }

    toKey(): string {
        return this.name + '=' + this.entityId;
    }
}
